import QtiImport from '../records/QtiImport';
import { Map } from 'immutable';
var getQtiImports = function getQtiImports(state) {
  return state.get('qtiImports', Map());
};
var getQtiImportById = function getQtiImportById(state, id) {
  return QtiImport.create(state.getIn(['qtiImports', id]));
};
export var getLatestQtiImportForParentWithType = function getLatestQtiImportForParentWithType(state, parentId, parentType) {
  var allImports = getQtiImports(state);
  var importsForType = allImports.valueSeq().filter(function (qtiImport) {
    return qtiImport.get('parentId') === parentId && qtiImport.get('parentType') === parentType;
  });
  // ids are strings, so we need to parse them below for maxBy to work properly
  var latestImport = importsForType.maxBy(function (i) {
    return parseInt(i.get('id'));
  });
  var id = latestImport && latestImport.get('id');
  return getQtiImportById(state, id);
};